import { render, staticRenderFns } from "./TheTestNavbarVertical.vue?vue&type=template&id=664435b0"
import script from "./TheTestNavbarVertical.vue?vue&type=script&lang=js"
export * from "./TheTestNavbarVertical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports